// import Swiper from "swiper";
import Swiper, {
  Navigation,
  Pagination,
  A11y,
  Autoplay,
  EffectFade,
} from "swiper";

class InitSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector(".swiper");
    this.config = {}
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.swiper = new Swiper(this.swiperEl, this.config);
  }


}

window.customElements.define("init-swiper", InitSwiper);